import { uniqWith } from 'es-toolkit';
import React from 'react';

import { INDETERMINATE } from '@paragon/client-tools';
import { angleEquals } from '@paragon/geometry-library';
import { AngleField } from '@paragon/material';

interface Props {
  readonly label: string;
  readonly defaultDisplayFormat?: 'degrees' | 'slope';

  readonly value: readonly number[];

  readonly onSubmit?: (valueInDegrees: number) => void;

  readonly min?: number;
  readonly max?: number;

  readonly disabled?: boolean;
}

export function MultiValueAngleInput(props: Props) {
  const uniqueValues = uniqWith(props.value, angleEquals);
  const value = uniqueValues.length === 1 ? uniqueValues[0] : INDETERMINATE;

  return (
    <AngleField
      canBeIndeterminate
      label={props.label}
      defaultDisplayFormat={props.defaultDisplayFormat}
      value={value}
      onSubmit={props.onSubmit}
      min={props.min}
      max={props.max}
      disabled={props.disabled}
    />
  );
}
